class Config {
    static GOOGLE_MAPS_API_KEY = 'AIzaSyB6AeGdWo-bwqqklp6kLGcOENfl3waZzYo';
};

export default Config;


// WEBPACK FOOTER //
// ./src/utils/Config.js